export const TOKEN_KEY = {
  ACCESS_TOKEN_KEY: "Authorization",
  REFRESH_TOKEN_KEY: "x-refresh-token",
};
